import React, {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import {withFreshToken} from "../../../router/sidebarRoute";
import {useTranslation} from "react-i18next";
import {useRecoilState, useRecoilValue, useSetRecoilState} from "recoil";
import {
    Avatar,
    Badge,
    Button,
    Col,
    Divider,
    Drawer,
    Dropdown,
    Layout,
    Menu,
    Popover,
    Row,
    Space,
    Tooltip,
    Upload
} from "antd";
import {PlusOutlined} from "@ant-design/icons";
import {
    globalBrandConfigState,
    globalBrandModuleSettingState,
    globalBrandSettingState,
    globalColorThemeState,
    globalLanguageListState,
    globalNotificationState,
    globalOpenGoLiveModalState,
    globalUnreadAnnouncementCountState,
    globalUnreadPushNotificationCountState,
    globalUserDetailState,
} from "../../../_common/global_state";
import useShared from "../../../_common/_shared";
import {useProfileFunction} from "../../../pages/profile/function";
import {useVerification} from "../../../_common/_authorize";
import {getPlatform} from "../../../api/graphql/platformDownload";
import QrModal from "./qr/qrModal";
import PlatformDownloadModal from "./platformDownload/platformDownloadModal";
import EditNavigationModal from "./editNavigationModal";
import dummyImg from "../../../assets/image/dummy.png";
import GoLiveModal from "./goLive";
import useLayoutFunction from "../../function";
import {useIsMobile} from "../../../_common/function";
import Announcement_4 from "../../../pages/announcement/view/layout_4";
import {getUserAnnouncementUnreadCount} from "../../../api/graphql/announcement";

const {Sider} = Layout;

export const Sider_4 = ({routes, registerField}) => {
    const {t} = useTranslation();
    const navigate = useNavigate();
    const isTablet = useIsMobile(992)
    const isMobile = useIsMobile(550)
    const {updateProfile} = useProfileFunction();
    const {IconModule, IconCommon, IconFlag} = useShared();
    const {changeLanguageHandler, filterAndGroupServers} = useLayoutFunction()
    const {handleTokenExpiration} = useVerification();

    const [openEditNavModal, setOpenEditNavModal] = useState(false);
    const [collapsed, setCollapsed] = useState(false);
    const [openQrModal, setOpenQrModal] = useState(false);
    const [openPlatformModal, setOpenPlatformModal] = useState(false);
    const [platformData, setPlatformData] = useState([]);
    const [openMorePopover, setIsOpenMorePopOver] = useState(false);
    const [openDrawers, setOpenDrawers] = useState([]);

    const brandSettingState = useRecoilValue(globalBrandSettingState);
    const brandConfigState = useRecoilValue(globalBrandConfigState);
    const brandModuleSetting = useRecoilValue(globalBrandModuleSettingState);
    const userDetails = useRecoilValue(globalUserDetailState);
    const languageListState = useRecoilValue(globalLanguageListState);
    const unreadPushNotificationCount = useRecoilValue(globalUnreadPushNotificationCountState);
    const setNotificationMessage = useSetRecoilState(globalNotificationState);
    const [colorState, setColorState] = useRecoilState(globalColorThemeState);
    const [unreadAnnouncementCount, setUnreadAnnouncementCount] = useRecoilState(globalUnreadAnnouncementCountState);
    const [openGoLiveModal, setOpenGoLiveModal] = useRecoilState(globalOpenGoLiveModalState);

    const userId = localStorage.getItem("userid")
    const themeClass = colorState === "dark" ? "dark-theme" : "light-theme";

    const uploadImage = async (e) => {
        const link = e?.file?.response?.data?.[0]
        if (link) {
            await updateProfile(userDetails?._id, {
                profileImage: link.toString(),
            });
        }
    };

    const categories = [
        ...new Set(
            routes.flatMap((route) => {
                if (route?.sub && !!route?.sub.length && route?.key === "more") {
                    return route?.sub.map((subRoute) => subRoute?.categoryName);
                }
                return [];
            })
        ),
    ];

    const openDrawer = (drawerKey) => {
        setOpenDrawers((prevOpenDrawers) => [...prevOpenDrawers, drawerKey]);
    };

    const closeDrawer = (drawerKey) => {
        setOpenDrawers((prevOpenDrawers) => prevOpenDrawers.filter((key) => key !== drawerKey));
    };

    const [hovered, setHovered] = useState(false);

    const handleMouseEnter = () => {
        setHovered(true);
    };

    const handleMouseLeave = () => {
        setHovered(false);
    };

    const toggleTheme = () => {
        const newColorState = colorState === "light" ? "dark" : "light";
        setColorState(newColorState);
        localStorage.setItem("color", newColorState);
    };

    const preload = async () => {
        const response = await getPlatform();
        const filtered = await filterAndGroupServers(response?.getPlatform?.data);
        setPlatformData(filtered);
        const unreadCount = await getUserAnnouncementUnreadCount(userId);
        setUnreadAnnouncementCount(unreadCount?.getUserAnnouncementByUserId?.unreadTotal);
    };

    useEffect(() => {
        preload();
    }, []);

    const languageDropdown = (
        <Menu className={"language-dropdown-menu"} selectedKeys={[localStorage.getItem("language")]}>
            {languageListState?.map((lang) => (
                <Menu.Item key={lang?.code} value={lang?.code} onClick={() => changeLanguageHandler(lang?.code)}>
                    <IconFlag countryCode={lang?.countryCode} className={"icon-button me-2"}/>
                    <small>{lang?.nativeName}</small>
                </Menu.Item>
            ))}
        </Menu>
    );

    const currentLanguageObj = languageListState?.find((lang) => lang?.code === localStorage.getItem("language"));

    return (
        <span id={"sidebar"} className={`${themeClass} ${collapsed ? "collapsed" : "expanded"}`}>
            <QrModal
                isModalOpen={openQrModal}
                handleCancel={() => setOpenQrModal(false)}
            />
            <PlatformDownloadModal
                isModalOpen={openPlatformModal}
                handleCancel={() => setOpenPlatformModal(false)}
                platformData={platformData}
            />
            <EditNavigationModal
                isModalOpen={openEditNavModal}
                handleCancel={() => setOpenEditNavModal(false)}
            />
            <GoLiveModal
                isModalOpen={openGoLiveModal}
                handleCancel={() => setOpenGoLiveModal(false)}
                registerField={registerField}
            />
            <Sider
                breakpoint={"lg"}
                width={220}
                collapsedWidth={"80"}
                className={"vh-full"}
                onCollapse={(value) => setCollapsed(value)}
                collapsible
                collapsed={collapsed}
            >
                <div
                    className={"sidebar-logo"}
                    style={{display: "flex", justifyContent: "space-between", alignItems: "center", padding: "16px"}}
                >
                    {!collapsed && (
                        <img
                            alt={"sidebar logo"}
                            className={"w-full h-full cursor-pointer"}
                            onClick={() => navigate("/dashboard")}
                            src={colorState === "dark" ? brandSettingState?.companyLogoInverse : brandSettingState?.companyLogo}
                        />
                    )}
                </div>
                {collapsed ? (
                    <div style={{maxHeight: "40px", marginTop: "3rem"}}>
                        <Upload
                            id={"upload-layout"}
                            name={"files"}
                            action={`${brandConfigState?.assetsURL}/api/upload/file`}
                            data={{
                                brand: brandConfigState?.assetsBrandName,
                                category: "profile"
                            }}
                            showUploadList={false}
                            beforeUpload={(file) => {
                                const isImage = file.type?.includes("image");
                                if (!isImage) {
                                    setNotificationMessage({
                                        status: "error",
                                        title: "",
                                        msg: t("errorMsg.type.invalidFileType"),
                                        key: "invalidFileType",
                                    });
                                }
                                return isImage || Upload.LIST_IGNORE;
                            }}
                            accept={"image/*"}
                            maxCount={1}
                            onChange={uploadImage}
                            onMouseEnter={handleMouseEnter}
                            onMouseLeave={handleMouseLeave}
                            className={`upload-container ${hovered ? "hovered" : ""}`}
                        >
                            <Avatar size={40} src={userDetails?.profileImage || dummyImg}/>
                            <div className={"plus-overlay-collapsed"}>
                                <PlusOutlined/>
                            </div>
                        </Upload>
                    </div>
                ) : (
                    <div className={"sidebar-profile-container container-fluid"}>
                        <Row align={"middle"} gutter={16} className={"container-fluid mx-0"}>
                            <Col span={6}>
                                <Upload
                                    id={"upload-layout"}
                                    name={"files"}
                                    action={`${brandConfigState?.assetsURL}/api/upload/file`}
                                    data={{
                                        brand: brandConfigState?.assetsBrandName,
                                        category: "profile"
                                    }}
                                    showUploadList={false}
                                    beforeUpload={(file) => {
                                        const isImage = file.type?.includes("image");
                                        if (!isImage) {
                                            setNotificationMessage({
                                                status: "error",
                                                title: "",
                                                msg: t("errorMsg.type.invalidFileType"),
                                                key: "invalidFileType",
                                            });
                                        }
                                        return isImage || Upload.LIST_IGNORE;
                                    }}
                                    accept={"image/*"}
                                    maxCount={1}
                                    onChange={uploadImage}
                                    onMouseEnter={handleMouseEnter}
                                    onMouseLeave={handleMouseLeave}
                                    className={`upload-container ${hovered ? "hovered" : ""}`}
                                >
                                    <Avatar
                                        src={userDetails?.profileImage || dummyImg}
                                        className={"sidebar-profile-img"}
                                    />
                                    <div className={"plus-overlay"}>
                                        <PlusOutlined/>
                                    </div>
                                </Upload>
                            </Col>
                            <Col span={18}>
                                <Row className={"sidebar-profile-name"}>
                                    <p>{userDetails?.username}</p>
                                </Row>
                                <Row className={"sidebar-profile-email"}>
                                    <Tooltip title={userDetails?.email}>
                                        <p>{userDetails?.email}</p>
                                    </Tooltip>
                                </Row>
                            </Col>
                        </Row>
                    </div>
                )}
                {userDetails?.clientAccountType === "demo" && (
                    <div className={"mx-4"}>
                        <Button
                            className={"platform_download primary-button"}
                            onClick={() => setOpenGoLiveModal(true)}
                        >
                            {t("common.goLive")}
                        </Button>
                    </div>
                )}
                <div className={"sidebarMenu"}>
                    {routes.map((route, index) => {
                        if (route?.sub && !!route?.sub?.length) {
                            const moreContent = (
                                <>
                                    {categories.map((category, i) => (
                                        <Row id={"layout-sider-popover"} key={i}>
                                            <Col span={24} className={"mt-2"}>
                                                <p className={"sub-title"}>
                                                    <strong>{t(`common.${category}`)}</strong>
                                                </p>
                                            </Col>
                                            {route?.sub
                                                ?.sort((a, b) => {
                                                    const categoryOrder = {common: 1, finance: 2, others: 3,};

                                                    const categoryComparison = categoryOrder[a.categoryName] - categoryOrder[b.categoryName];
                                                    if (categoryComparison !== 0) return categoryComparison;
                                                    return categoryOrder[a.key] - categoryOrder[b.key];
                                                })
                                                ?.filter((subRoute) => subRoute?.categoryName === category)
                                                ?.map((subRoute, subRouteIndex) => {
                                                    const filterModule = brandModuleSetting?.filter((item) => !!item?.isEnabled && subRoute?.label === item?.name);
                                                    const drawerKey = `${subRoute?.label}`;
                                                    const isDrawerOpen = openDrawers.includes(drawerKey);
                                                    if (filterModule && subRoute?.sub) return (
                                                        <div key={subRouteIndex}>
                                                            <Tooltip
                                                                title={subRoute?.label}
                                                                placement={"right"}
                                                                getPopupContainer={(triggerNode) => triggerNode.parentElement}
                                                            >
                                                                <Col
                                                                    xs={24}
                                                                    md={24}
                                                                    lg={24}
                                                                    className={"layout-sider-popover-btn text-center mb-2 cursor-pointer"}
                                                                    onClick={() => openDrawer(drawerKey)}
                                                                >
                                                                    {subRoute?.icon}
                                                                </Col>
                                                            </Tooltip>
                                                            <Drawer
                                                                key={drawerKey}
                                                                id={"drawerContainer"}
                                                                onClose={() => closeDrawer(drawerKey)}
                                                                open={isDrawerOpen}
                                                                className={"popoverDrawer"}
                                                                getContainer={false}
                                                                title={
                                                                    <Row justify={"start"}>
                                                                        <Button
                                                                            type={"link"}
                                                                            onClick={() => closeDrawer(drawerKey)}
                                                                        >
                                                                            <p>X</p>
                                                                        </Button>
                                                                    </Row>
                                                                }
                                                                closeIcon={false}
                                                            >
                                                                <Row className={"text-center"}>
                                                                    {subRoute?.sub?.map((subSubRoute) => (
                                                                        <Col
                                                                            className={"mb-4 cursor-pointer"}
                                                                            key={subSubRoute?.label}
                                                                            xs={24}
                                                                            md={24}
                                                                            lg={24}
                                                                            onClick={() => {
                                                                                closeDrawer(drawerKey)
                                                                                setIsOpenMorePopOver(false)
                                                                                isTablet && setCollapsed(true)
                                                                                subSubRoute?.type === "_blank" ? window.open(withFreshToken(subSubRoute?.path), "_blank") : navigate(subSubRoute?.path);
                                                                            }}
                                                                        >
                                                                            <Tooltip title={subSubRoute?.label}>
                                                                                <IconModule
                                                                                    iconName={subSubRoute?.label}
                                                                                    className={"sidebarIcon"}
                                                                                    title={subSubRoute?.label.replace(".", "").replace(/[-\s+]/g, "_").toLowerCase()}
                                                                                />
                                                                            </Tooltip>
                                                                        </Col>
                                                                    ))}
                                                                </Row>
                                                            </Drawer>
                                                        </div>
                                                    );

                                                    return (
                                                        <Tooltip
                                                            key={subRouteIndex}
                                                            title={subRoute?.label}
                                                            placement={"right"}
                                                            getPopupContainer={(triggerNode) => triggerNode.parentElement}
                                                        >
                                                            <Col
                                                                key={subRoute?.label}
                                                                xs={24}
                                                                md={24}
                                                                lg={24}
                                                                className={"layout-sider-popover-btn text-center mb-2 cursor-pointer"}
                                                                onClick={() => {
                                                                    setIsOpenMorePopOver(false);
                                                                    isTablet && setCollapsed(true)
                                                                    subRoute?.type === "_blank" ? window.open(withFreshToken(subRoute?.path), "_blank") : navigate(subRoute?.path);
                                                                }}
                                                            >
                                                                {subRoute?.icon}
                                                            </Col>
                                                        </Tooltip>
                                                    );
                                                })}
                                        </Row>
                                    ))}
                                    {route?.key === "more" && (
                                        <Col span={24} className={"text-center editNavigation"}>
                                            <Divider style={{margin: "0.2rem 0", background: "var(--divider-color)"}}/>
                                            <Button
                                                type={"link"}
                                                onClick={() => {
                                                    setOpenEditNavModal(true);
                                                    setIsOpenMorePopOver(false);
                                                }}
                                            >
                                                {collapsed ? t("common.edit") : t("common.editNavigation")}
                                            </Button>
                                        </Col>
                                    )}
                                </>
                            );

                            const content = (
                                <Row id={"layout-sider-popover"}>
                                    {route?.sub?.map((subRoute, subRouteIndex) => (
                                        <Tooltip
                                            key={subRouteIndex}
                                            title={subRoute?.label}
                                            placement={"right"}
                                            getPopupContainer={(triggerNode) => triggerNode.parentElement}
                                        >
                                            <Col
                                                key={subRoute?.label}
                                                xs={12}
                                                md={8}
                                                lg={6}
                                                className={`layout-sider-popover-btn text-center cursor-pointer ${route?.sub?.length > 4 ? "mt-1 mb-2" : "mb-0"}`}
                                                onClick={() => {
                                                    isTablet && setCollapsed(true)
                                                    subRoute?.type === "_blank" ? window.open(withFreshToken(subRoute?.path), "_blank") : navigate(subRoute?.path);
                                                }}
                                            >
                                                {subRoute?.icon}
                                            </Col>
                                        </Tooltip>
                                    ))}
                                </Row>
                            );

                            return (
                                <div key={index}>
                                    {route?.key === "more" ? (
                                        <Popover
                                            trigger={"click"}
                                            open={openMorePopover}
                                            destroyTooltipOnHide
                                            className={"setPopoverCustom"}
                                            content={moreContent}
                                            getPopupContainer={(triggerNode) => triggerNode.parentElement}
                                            placement={"right"}
                                            onOpenChange={(bool) => setIsOpenMorePopOver(bool)}
                                        >
                                            <Col
                                                onClick={() => setIsOpenMorePopOver(!openMorePopover)}
                                                span={24}
                                                className={"text-center mb-2 cursor-pointer"}
                                            >
                                                {route?.icon}
                                            </Col>
                                        </Popover>
                                    ) : (
                                        <Popover
                                            trigger={"click"}
                                            destroyTooltipOnHide
                                            content={content}
                                            placement={"right"}
                                            getPopupContainer={(triggerNode) => triggerNode.parentElement}
                                        >
                                            <Col span={24} className={"text-center mb-2 cursor-pointer"}>
                                                {route?.icon}
                                            </Col>
                                        </Popover>
                                    )}
                                </div>
                            );
                        }

                        return (
                            <Tooltip
                                key={index}
                                title={route?.label}
                                placement={"right"}
                                getPopupContainer={(triggerNode) => triggerNode.parentElement}
                            >
                                <Col
                                    span={24}
                                    className={"text-center"}
                                    key={route?.label}
                                    onClick={() => {
                                        isTablet && setCollapsed(true)
                                        route?.type === "_blank" ? window.open(withFreshToken(route?.path), "_blank") : navigate(route?.path);
                                    }}
                                    style={{cursor: "pointer", flex: "none"}}
                                >
                                    {route?.icon}
                                </Col>
                            </Tooltip>
                        );
                    })}
                </div>
                <div className={"function-bar"}>
                    <ul>
                        <li>
                            <Dropdown
                                getPopupContainer={(triggerNode) => triggerNode.parentElement}
                                overlay={languageDropdown}
                            >
                                <a onClick={(e) => e?.preventDefault()}>
                                    <IconFlag countryCode={currentLanguageObj?.countryCode} className={"icon-button"}/>
                                </a>
                            </Dropdown>
                        </li>
                        <li>
                            <Tooltip title={t("referral.modal.title")}>
                                <button
                                    className={"icon-button"}
                                    onClick={() => setOpenQrModal(true)}
                                >
                                    <IconCommon iconName={"qr"} className={"icon-button"}/>
                                </button>
                            </Tooltip>
                        </li>
                        <li>
                            <Tooltip title={t("brandSetting.theme")}>
                                <button onClick={toggleTheme} className={"icon-button"}>
                                    <IconCommon
                                        isAlwaysActive
                                        iconName={colorState === "light" ? "sun" : "moon"}
                                        className={"h-full w-full"}
                                    />
                                </button>
                            </Tooltip>
                        </li>
                        <li>
                            <Badge count={unreadAnnouncementCount + unreadPushNotificationCount} size={"small"}>
                                <Tooltip title={"Announcement"}>
                                    <Popover
                                        autoAdjustOverflow
                                        placement={isMobile ? "top" : "rightTop"}
                                        trigger={["click"]}
                                        content={<Announcement_4 isHeader/>}
                                        id={"header-announcement"}
                                        getPopupContainer={(triggerNode) => triggerNode.parentElement}
                                    >
                                        <button className={"icon-button"}>
                                            <IconCommon iconName={"bell"} className={"icon-button"}/>
                                        </button>
                                    </Popover>
                                </Tooltip>
                            </Badge>
                        </li>
                    </ul>
                    <Space direction={"vertical"} className={"w-full"}>
                        <button
                            className={"primary-button"}
                            onClick={() => setOpenPlatformModal(true)}
                        >
                        <IconCommon iconName={"import"} className={"icon-button self-center"}/>
                            {!collapsed && <span>{t("common.download")}</span>}
                        </button>
                        <button
                            className={"primary-button"}
                            onClick={() => handleTokenExpiration(true)}
                        >
                        <IconCommon iconName={"logout"} className={"icon-button self-center"}/>
                            {!collapsed && <span>{t("common.logOut")}</span>}
                        </button>
                    </Space>
                </div>
            </Sider>
        </span>
    );
};
